export default "__VITE_ASSET__uPhp6jrO__"